import { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import mixpanel from 'mixpanel-browser';
import { MixpanelProvider } from 'react-mixpanel';
import { initMixpanel } from 'utils/functions/mixpanel';
import store from 'redux/store';
import themeData from 'utils/theme/themeData';
import MainContainer from 'modules/common/containers/MainContainer';

const App = () => {
  const [hasMixpanelLoaded, setHasMixpanelLoaded] = useState(false);

  useEffect(() => {
    initMixpanel();
    setHasMixpanelLoaded(true);
  }, []);

  return (
    (hasMixpanelLoaded && (
      <Provider store={store}>
        <BrowserRouter>
          <ThemeProvider theme={themeData}>
            <MixpanelProvider mixpanel={mixpanel}>
              <MainContainer />
            </MixpanelProvider>
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    )) ||
    ''
  );
};

export default App;
